module.exports = __webpack_public_path__ + "static/media/fixa.d5853afd.mp3";